export default {
  data() {
    return {
      //row 1
      dashboard800Time: '',
      dashboard800TimeInterval: null,
      dashboard800CurrentMissionCount: null,
      dashboard8001019MissionCount: null,
      dashboard800endMissionCount: null,
      //row 2
      dashboard800SendAverge: null,
      dashboardFollowUpFinishCount: null,
      dashboardIMG: require('@/assets/images/dashboard800Image.png'),
      //pie rank
      dashboard800PieRankChartOptions: {
        colors: [],
        chart: {
          renderTo: 'dashboard800PieRankChart',
          type: 'pie',
          height: '240px',
          redraw: true,
        },
        title: {
          text: '',
        },
        legend: {
          layout: 'vertical',
          useHTML: true,
          enabled: false,
          rtl: true,
          align: 'right',
          verticalAlign: 'middle',
          itemMarginTop: 3,
          itemMarginBottom: 3,
          itemStyle: {
            fontSize: '10px',
            direction: 'ltr',
            textAlign: 'left',
            width: '80px',
          },
        },
        series: [
          {
            name: '',
            keys: ['name', 'y', 'tooltipText'],
            colorByPoint: true,
            data: [],
            size: '100%',
            slicedOffset: 5,
            showInLegend: true,
            useHTML: true,
          },
        ],
        plotOptions: {
          pie: {
            innerSize: 90,
            depth: 50,
            dataLabels: {
              enabled: true,
              useHTML: true,
              style: {
                fontSize: '9px',
                textOutline: 'none',
                color: '#ffffff',
              },
            },
          },
          useHTML: true,
          series: {
            title: 'اولویت ها',
            cursor: 'pointer',
            borderRadius: 5,
            dataLabels: [
              {
                enabled: true,
                distance: 15,
                format: '{point.name}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
              {
                enabled: true,
                distance: '-20%',
                format: '{point.y}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
            ],
          },
        },
        tooltip: {
          useHTML: true,
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{point.tooltipText}</span>: <span  style="color:white">{point.y}</span></div><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">درصد</span>: <span  style="color:white">{point.percentage:.2f}</span></div>',
        },
      },
      //Operation rank
      dashboard800PieOperationChartOptions: {
        colors: [
          '#665FBB',
          '#B6DCFE',
          '#B8B8F3',
          '#55BCE8',
          '#D1D0A3',
          '#298A9B',
          '#D6558B',
          '#FFD2FC',
          '#E6E6E9',
          '#1D4E89',
          '#E2856E',
          '#775048',
        ],
        chart: {
          renderTo: 'dashboard800PieOperationChart',
          type: 'pie',
          height: '240px',
          redraw: true,
        },
        title: {
          text: '',
        },
        legend: {
          layout: 'vertical',
          useHTML: true,
          enabled: false,
          rtl: true,
          align: 'right',
          verticalAlign: 'middle',
          itemMarginTop: 3,
          itemMarginBottom: 3,
          itemStyle: {
            fontSize: '10px',
            direction: 'ltr',
            textAlign: 'left',
            width: '80px',
          },
        },
        series: [
          {
            name: '',
            keys: ['name', 'y', 'tooltipText'],
            colorByPoint: true,
            data: [],
            size: '100%',
            slicedOffset: 5,
            showInLegend: true,
            useHTML: true,
          },
        ],
        plotOptions: {
          pie: {
            innerSize: 0,
            depth: 0,
            dataLabels: {
              enabled: true,
              useHTML: true,
              style: {
                fontSize: '9px',
                textOutline: 'none',
                color: '#ffffff',
              },
            },
          },
          useHTML: true,
          series: {
            title: 'عملیات',
            cursor: 'pointer',
            borderRadius: 5,
            dataLabels: [
              {
                enabled: true,
                distance: 15,
                format: '{point.name}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
              {
                enabled: true,
                distance: '-20%',
                format: '{point.y}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
            ],
          },
        },
        tooltip: {
          useHTML: true,
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{point.tooltipText}</span>: <span  style="color:white">{point.y}</span></div><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">درصد</span>: <span  style="color:white">{point.percentage:.2f}</span></div>',
        },
      },
      //row 3
      // dashboardIMG2: require('@/assets/images/dashboard800Image2.png'),
      dashboardIMG2: require('@/assets/images/bg_card_line.svg'),
      dashboardBG: require('@/assets/images/bg_card.svg'),
      dashboard800ActiveCode: null,
      dashboard800ReadyCode: null,
      dashboard800OutOfServiceCode: null,
      dashboard800LackOfCode: null,
      dashboard800LocationConfirmationCode: null,
      //line mission chart
      dashboard800LineMissionChartOptions: {
        chart: {
          type: 'spline',
          height: '240px',
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        xAxis: {
          categories: [],
        },
        legend: {
          enabled: false,
        },
        yAxis: {
          title: {
            text: '',
          },
          labels: {
            format: '{value}',
          },
        },
        tooltip: {
          useHTML: true,
          crosshairs: true,
          shared: true,
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: '#666666',
              lineWidth: 1,
            },
          },
        },
        series: [
          {
            name: 'ماموریت ها',
            marker: {
              symbol: 'diamond',
            },
            data: [],
          },
        ],
      },
      //line call chart
      dashboard800LineCallChartOptions: {
        chart: {
          type: 'spline',
          height: '240px',
          zoomType: 'x',
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        xAxis: {
          categories: [],
          type: 'datetime',
        },
        legend: {
          enabled: true,
          useHTML: true,
        },
        yAxis: {
          title: {
            text: '',
          },
          labels: {
            format: '{value}',
          },
        },
        tooltip: {
          useHTML: true,
          crosshairs: true,
          shared: true,
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: '#666666',
              lineWidth: 1,
            },
          },
        },
        series: [],
      },
    };
  },
  methods: {
    ready800Dashboard: function (data) {
      let duration = Math.round(data.workingHours.valueDouble);
      duration = duration * 1000;
      this.dashboard800TimeInterval = setInterval(() => {
        duration = duration + 1000;
        this.dashboard800Time = this.msToTime(duration);
      }, 1000);
      this.dashboard800CurrentMissionCount = data.currentMissions.valueLong;
      this.dashboard8001019MissionCount = data.canceledMissions.valueLong;
      this.dashboard800endMissionCount = data.dispatchedMissions.valueLong;
      let duration2 = Math.round(data.dispatchTimeAverage.valueLong);
      duration2 = duration2 * 1000;
      this.dashboard800SendAverge = this.msToTime(duration2);
      this.dashboardFollowUpFinishCount = data.editByFollowUpConfirms.valueLong;
      //pie rank chart
      let pieChartData = JSON.parse(JSON.stringify([]));
      let pieChartTempArray = JSON.parse(JSON.stringify([]));
      pieChartTempArray = JSON.parse(JSON.stringify(data.missionsByRank));
      for (let i = 0; i < pieChartTempArray.length; i++) {
        if (
          pieChartTempArray[i].title == 'سفید' &&
          !this.dashboard800PieRankChartOptions.colors.includes('#EBEBEB')
        ) {
          this.dashboard800PieRankChartOptions.colors.push('#EBEBEB');
        } else if (
          pieChartTempArray[i].title == 'سبز' &&
          !this.dashboard800PieRankChartOptions.colors.includes('#2EBA7F')
        ) {
          this.dashboard800PieRankChartOptions.colors.push('#2EBA7F');
        } else if (
          pieChartTempArray[i].title == 'زرد' &&
          !this.dashboard800PieRankChartOptions.colors.includes('#FFBD55')
        ) {
          this.dashboard800PieRankChartOptions.colors.push('#FFBD55');
        } else if (
          pieChartTempArray[i].title == 'قرمز' &&
          !this.dashboard800PieRankChartOptions.colors.includes('#DA6757')
        ) {
          this.dashboard800PieRankChartOptions.colors.push('#DA6757');
        }
        pieChartData.push({
          name: pieChartTempArray[i].title,
          y: pieChartTempArray[i].valueLong,
          tooltipText: 'تعداد',
        });
      }
      pieChartData = JSON.parse(JSON.stringify(pieChartData));
      this.dashboard800PieRankChartOptions.series[0].data = [];
      this.dashboard800PieRankChartOptions.series[0].data = pieChartData;
      //pie operation
      let pieChartData2 = JSON.parse(JSON.stringify([]));
      let pieChartTempArray2 = JSON.parse(JSON.stringify([]));
      pieChartTempArray2 = JSON.parse(JSON.stringify(data.userOperations));
      for (let i = 0; i < pieChartTempArray2.length; i++) {
        pieChartData2.push({
          name: pieChartTempArray2[i].title,
          y: pieChartTempArray2[i].valueLong,
          tooltipText: 'تعداد',
        });
      }
      pieChartData2 = JSON.parse(JSON.stringify(pieChartData2));
      this.dashboard800PieOperationChartOptions.series[0].data = [];
      this.dashboard800PieOperationChartOptions.series[0].data = pieChartData2;
      //rows 3
      this.dashboard800ActiveCode = data.activeCodes.valueLong;
      this.dashboard800ReadyCode = data.readyCodes.valueLong;
      this.dashboard800OutOfServiceCode = data.outOfServiceCodes.valueLong;
      this.dashboard800LackOfCode = data.lackOfCodeMissions.valueLong;
      this.dashboard800LocationConfirmationCode = data.locationConfirmationMissions.valueLong;
      //rows 4
      if (data.missionsByDate.length > 0) {
        for (let i = 0; i < data.missionsByDate.length; i++) {
          let text = data.missionsByDate[i].title.split(' ');
          this.dashboard800LineMissionChartOptions.xAxis.categories.push(text[1]);
          this.dashboard800LineMissionChartOptions.series[0].data.push(
            data.missionsByDate[i].valueLong,
          );
        }
      }
      //rows 5
      if (data.callsByDate.length > 0) {
        let info = [];
        for (let j = 0; j < data.callsByDate[0].subItems.length; j++) {
          let text = data.callsByDate[0].subItems[j].title.split(' ');
          this.dashboard800LineCallChartOptions.xAxis.categories.push(text[1]);
        }
        for (let i = 0; i < data.callsByDate.length; i++) {
          info.push({ name: data.callsByDate[i].title, data: [] });
          for (let j = 0; j < data.callsByDate[i].subItems.length; j++) {
            info[i].data.push(data.callsByDate[i].subItems[j].valueLong);
          }
        }
        this.dashboard800LineCallChartOptions.series = info;
      }
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
  },
};
